// src/menu-items/incentives.jsx
// Own nav group for the gamification program's admin surfaces (approved
// 2026-07-05): Management was already ~14 items and the program adds more by
// Phase 4. Holds the Incentives program editor + Cash-Out Requests (moved
// from Management; item ids kept so any settings keyed on them still apply).
// Host Payouts deliberately STAYS under Management — it pre-dates the game
// and is core payroll ops. Phase 3–4 admin features land as TABS on the
// Incentives page, not as new menu items.

import { ROLES } from '../lib/auth/roles';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

const incentives = {
  id: 'group-incentives',
  title: 'Incentives',
  type: 'group',
  children: [
    {
      id: 'admin-incentives',
      title: 'Program Settings',
      type: 'item',
      url: '/admin/incentives',
      icon: () => <EmojiEventsIcon sx={{ fontSize: 21 }} />,
      allowedRoles: [ROLES.ADMIN]
    },
    {
      id: 'admin-cashouts',
      title: 'Cash-Out Requests',
      type: 'item',
      url: '/admin/cashouts',
      icon: () => <AccountBalanceIcon sx={{ fontSize: 21 }} />,
      allowedRoles: [ROLES.ADMIN]
    }
  ]
};

export default incentives;
